import React, {
  ElementType,
  PropsWithChildren,
  ReactElement,
  ReactNode,
} from 'react';
import { Disclosure } from '@headlessui/react';
import cn from 'classnames';

type AccordionProps = PropsWithChildren<{
  titleComponent: ReactElement;
  buttonClassName?: string;
  panelClassName?: string;
  defaultOpen?: boolean;
  as?: ElementType<any>;
  className?: string;
  children: ReactNode | Array<ReactNode>;
}>;

export default function Accordion(props: AccordionProps) {
  const {
    titleComponent,
    buttonClassName,
    panelClassName,
    defaultOpen,
    as,
    className,
  } = props;

  return (
    <Disclosure defaultOpen={defaultOpen} as={as}>
      {({ open }) => (
        <div className={className}>
          <Disclosure.Button className={cn('w-full', buttonClassName)}>
            {React.cloneElement(titleComponent, { isOpen: open })}
          </Disclosure.Button>
          <Disclosure.Panel className={panelClassName}>
            {props.children}
          </Disclosure.Panel>
        </div>
      )}
    </Disclosure>
  );
}
